'use strict';

var base = require('org/product/wishlist');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked to add a product to the wishlist
 */
function displayMessage(data, button) {
    if (button.hasClass('product-added')) {
        button.removeClass('b-product_name-fav_button').addClass('b-product_name-fav_selectButton');
    } else {
        button.removeClass('b-product_name-fav_selectButton').addClass('b-product_name-fav_button');
    }
}

/**
 * Checks if a size is selected for the product.
 * If no size is chosen, an error message is displayed to prompt the user,
 * guiding them to select a size before adding the item to the wishlist.
 * @param {jQuery} $el - jQuery object containing the element to search for the product attribute.
 * @param {boolean} isProductAddedToWishlist - Indicates whether the product is already added to the wishlist.
 * @returns {boolean} - True if size is selected, false otherwise.
 */
function checkSizeSelection($el, isProductAddedToWishlist) {
    const scrollAnimate = require('org/components/scrollAnimate');

    const attributeKey = 'size';

    if (isProductAddedToWishlist) {
        return true;
    }

    let attribute = $el.find('.b-product_attrs-item[data-attr="' + attributeKey + '"]');

    if (!attribute.length) {
        return true;
    }

    const isSizeSelected = attribute.find('.m-active').length !== 0 || attribute.find('.selected').length !== 0;

    if (isSizeSelected) {
        attribute.removeClass('has-error');
        attribute.find('.invalid-feedback').hide();
        return isSizeSelected;
    }

    attribute.addClass('has-error');

    if (attribute.find('.invalid-feedback').length) {
        attribute.find('.invalid-feedback').show();
    } else {
        attribute.append(
            '<div class="invalid-feedback">'
            + attribute.data('wishlist-error-label')
            + '</div>'
        );
    }

    scrollAnimate(attribute);

    return isSizeSelected;
}

base.addToWishlist = function () {
    $('body').on('click', '.add-to-wish-list', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        var button = $(this).find('.js-whislist-icon');
        var style = $(this).attr('data-analytics-style');
        var sku = $(this).attr('data-analytics-sku');
        var pidUrl = $('.b-quantity-select').find(':selected').attr('data-url');
        var result = {};
        if (pidUrl !== null && pidUrl !== undefined) {
            pidUrl.replace(/[?&amp;]+([^=&amp;]+)=([^&amp;]*)/gi, function (str, key, value) {
                result[key] = value;
            });
        }
        var pid = $(this).attr('data-pid');
        var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
        var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
        optionId = optionId || null;
        optionVal = optionVal || null;
        if (!url || !pid) {
            return;
        }

        var $attrsContainer = $('.b-product_attrs', this.$el);
        var isProductAddedToWishlist = button.hasClass('product-added');
        var isSizeSelected = checkSizeSelection($attrsContainer, isProductAddedToWishlist);

        if (!isSizeSelected) {
            return;
        }

        if ($(this).find('.js-whislist-icon').hasClass('product-added')) {
            url = $(this).attr('remove-href');
            $(this).find('.js-whislist-icon').removeClass('product-added');
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                data: {
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal
                },
                success: function (data) {
                    displayMessage(data, button);
                    $('body').trigger('wishlist:removeItemSuccess', {
                        style: style,
                        sku: sku
                    });
                },
                error: function (err) {
                    displayMessage(err, button);
                }
            });
        } else {
            $(this).find('.js-whislist-icon').addClass('product-added');
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal
                },
                success: function (data) {
                    displayMessage(data, button);
                    $('body').trigger('wishlist:addItemSuccess', {
                        style: style,
                        sku: sku
                    });
                },
                error: function (err) {
                    displayMessage(err, button);
                }
            });
        }
    });
};

module.exports = base;
